import { formatDate } from '../../CommonFunctions/CommonFunctions';

const CustomerListItem = ({ appointment }) => (
    <div className="d-flex flex-column shadow-sm p-2 px-3 mb-4">
        <div className="d-flex flex-row justify-content-between align-items-center">
            <h6 className="m-0">{appointment.Name}</h6>
            <span>{formatDate(appointment.AppointmentDate)}</span>
        </div>
        {appointment.ServiceName && (
            <div className="d-flex flex-row justify-content-start align-items-center flex-wrap">
                <span className="me-1">{appointment.ServiceName}</span>
                {appointment.DoctorName && <span>(Dr. {appointment.DoctorName})</span>}
            </div>
        )}
    </div>
);

const CustomerList = ({ appointments, isLoading, listWidth }) => {
    if (isLoading) {
        return (
            <div className="d-flex flex-row justify-content-center pt-5">
                <div className="spinner-border text-info" aria-hidden="true"><span className="visually-hidden">Loading...</span></div>
            </div>
        );
    }

    return (
        <div className="d-flex flex-column px-3 px-md-5 my-4" style={{ minWidth: listWidth }}>
            {appointments.length > 0 ? (
                appointments.map((appointment) => (
                    <CustomerListItem key={appointment.BookingConsultationId} appointment={appointment} />
                ))
            ) : (
                <span className="text-danger text-center fw-semibold fs-5">No Customers till the date.</span>
            )}
        </div>
    );
};

export default CustomerList;
